
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 172 67"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#778387"}},[_c('path',{attrs:{"opacity":".1","d":"M0 66.5h172M0 55.5h172M0 44.5h172M0 33.5h172M0 22.5h172M0 11.5h172M0 .5h172"}})]),_c('rect',{attrs:{"width":"160","height":"4","rx":"2","transform":"translate(5 3.545)","fill":"#fff"}}),_c('rect',{attrs:{"width":"160","height":"4","rx":"2","transform":"translate(5 14.544)","fill":"#fff"}}),_c('rect',{attrs:{"width":"160","height":"4","rx":"2","transform":"translate(5 25.544)","fill":"#fff"}}),_c('rect',{attrs:{"width":"160","height":"4","rx":"2","transform":"translate(5 36.544)","fill":"#fff"}}),_c('rect',{attrs:{"width":"160","height":"4","rx":"2","transform":"translate(5 47.544)","fill":"#fff"}}),_c('rect',{attrs:{"width":"64","height":"4","rx":"2","transform":"translate(5 59.544)","fill":"#fff"}})])
          )
        }
      }
    